import {
  CheckCircleIcon,
  ClockIcon,
  ArrowPathIcon,
  UserIcon,
} from '@heroicons/react/24/outline';

export const LAUNCHES_EMPTY_ICON_MAP = {
  checkCircle: CheckCircleIcon,
  clock: ClockIcon,
  history: ArrowPathIcon,
  user: UserIcon,
};
